import { Fragment, ReactNode, useCallback, useState } from 'react';
import {
  getShiftedDatetime,
  removeShiftedDatetime,
  setShiftedDatetime,
} from 'utils/shiftedDateTime';
import classNames from 'classnames';
import dayjs from 'dayjs';
import EyeClosedIcon from 'assets/icons/eye-closed.svg?react';
import EyeOpenIcon from 'assets/icons/eye-open.svg?react';
import SandclockIcon from 'assets/icons/sandClock.svg?react';
import styles from './BuildInfoContainer.module.scss';

export type BuildInfoContainerProps = {
  className?: string;
  items: { key: string; value: string }[];
  component?: ReactNode;
  selectedEnv?: string;
};

const TODAY = dayjs().format('YYYY-MM-DD');

export const BuildInfoContainer = ({
  className,
  items,
  component,
  selectedEnv,
}: BuildInfoContainerProps) => {
  const defaultDay = new Date().toISOString().split('T')[0]; // Today

  const sessionTime = getShiftedDatetime();
  const sessionDay = sessionTime && sessionTime.split(' ')[0]; // Remove datetime

  const [isExpanded, setIsExpanded] = useState(
    localStorage.getItem('buildInfoOpen') === 'true',
  );
  const [day, setDay] = useState<string | undefined>(sessionDay || defaultDay);

  const toggleExpanded = useCallback(() => {
    setIsExpanded((prev) => {
      localStorage.setItem('buildInfoOpen', `${!prev}`);
      return !prev;
    });
  }, []);

  const onChangeDay = (nextDay: string | undefined) => {
    if (nextDay) setShiftedDatetime(nextDay);
    else removeShiftedDatetime();

    setDay(nextDay || defaultDay);
  };

  return (
    <div
      className={classNames(
        styles.wrapper,
        !isExpanded && styles.transparent,
        className,
      )}
    >
      <div>
        {isExpanded && items.length > 0 && (
          <div className={styles.grid}>
            {items.map(({ key, value }) => (
              <Fragment key={key}>
                <div>{key}</div>
                <div dangerouslySetInnerHTML={{ __html: value }} />
              </Fragment>
            ))}
            <Fragment>
              <div>Time</div>
              <div className={styles['time-row']}>
                <input
                  className={styles['input-date']}
                  onChange={(nextValue) => onChangeDay(nextValue.target.value)}
                  type="date"
                  value={day}
                />
                {day !== TODAY && (
                  <SandclockIcon
                    height="20"
                    onClick={() => {
                      onChangeDay(undefined);
                    }}
                    width="20"
                  />
                )}
              </div>
            </Fragment>
          </div>
        )}

        {isExpanded && component}

        {!isExpanded && selectedEnv !== undefined && selectedEnv}
      </div>

      <div className={styles['hide-icon-wrapper']} onClick={toggleExpanded}>
        {isExpanded ? (
          <EyeOpenIcon className={styles['hide-icon']} />
        ) : (
          <EyeClosedIcon className={styles['hide-icon']} />
        )}
      </div>
    </div>
  );
};
